import React, { useEffect, useRef, useState } from 'react';
import { uiText } from '../../i18n/uiText';

export function normalizeTime(value) {
  const match = /^(\d{1,2}):?(\d{2})$/.exec(value);
  if (!match || Number(match[1]) > 23 || Number(match[2]) > 59) return '';
  return `${match[1].padStart(2, '0')}:${match[2]}`;
}

// A plain text field preserves the cursor and accepts 0930 or 09:30. Browser
// date/time segmented inputs change focus while a controlled value is typed.
export default function SafeTimeInput({ value, onChange, required = false, ...props }) {
  const ref = useRef(null);
  const [text, setText] = useState(value || '');
  useEffect(() => { if (document.activeElement !== ref.current) setText(value || ''); }, [value]);
  useEffect(() => { ref.current?.setCustomValidity((text && !normalizeTime(text)) || (required && !text) ? uiText('Введите время от 00:00 до 23:59.') : ''); }, [text, required]);
  return <input {...props} ref={ref} type="text" className="form-control" inputMode="numeric" maxLength={5} placeholder="09:30" autoComplete="off" value={text}
    onChange={e => { const raw = e.target.value.replace(/[^0-9:]/g, ''); setText(raw); onChange(normalizeTime(raw)); }}
    onBlur={() => { const normalized = normalizeTime(text); if (normalized) setText(normalized); }} />;
}
